import Title from "../../../components/ui/Title";
import UserLayout from "../../../layouts/user";
import WishlistCourses from "./_components/WishlistCourses";

const breadcrumb = [
  {
    title: "হোম",
    path: "/",
  },
  {
    title: "ড্যাশবোর্ড",
  },
];

export default function UserWishlist() {
  return (
    <UserLayout title="পছন্দের কোর্স তালিকা" breadcrumb={breadcrumb}>
      <div className="pb-6 mb-6 border-b border-theme-zinc-200">
        <Title className="text-2xl">পছন্দের কোর্স তালিকা</Title>
      </div>

      <WishlistCourses />
    </UserLayout>
  );
}
